import {
  IRolAgente,
  IRolAgentePost,
} from '../../core/interfaces/agents.interface';

export class GetAllRolAgenteAction {
  static readonly type = '[RolAgente] Get All';
  constructor() {}
}

export class GetRolAgenteByUuidAction {
  static readonly type = '[RolAgente] Get By UUID';
  constructor(public payload: string) {}
}

export class CreateRolAgenteAction {
  static readonly type = '[RolAgente] Create';
  constructor(public payload: IRolAgentePost) {}
}

export class UpdateRolAgenteAction {
  static readonly type = '[RolAgente] Update';
  constructor(public payload: { uuid: string; data: IRolAgentePost }) {}
}

export class DeleteRolAgenteAction {
  static readonly type = '[RolAgente] Delete';
  constructor(public payload: string) {}
}

